<div *ngIf="shouldShowError">
    <p *ngFor="let error of listOfErrors()" class="text-danger">
        <small>{{error | async}}</small>
    </p>
</div>